import { Col, Row } from 'antd';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import TranslateText from 'components/hoc/TranslateText';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { IZadostDataNU, nuPlatbaApi } from 'services/nezarazenyUcet/nuDedictvi';
import formatNumber from 'utils/formatNumber';
// import OBJED from './OBJED';

interface IPLODLO {
    zadostData?: IZadostDataNU;
}

const PLODLO: React.FC<IPLODLO> = props => {
    // const { zadostData } = props;
    // const [stav, setStav] = useState<boolean>(false);

    // const onClick = () => {
    //     setStav(true);
    // };

    const { zadostData } = props;
    const history = useHistory();
    const [errStatus, setErrStatus] = useState<number>();
    const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
    const { token } = useParams<{ token: string }>(); // Bank ID token sebran z urlky
    // const [stav, setStav] = useState<boolean>(false);

    useEffect(() => {
        return () => setDisableSubmit(false);
    }, []);

    const routeChange = () => {
        let path = zadostData?.idzadosti
            ? '/nezarazeny-ucet-zjisteni/bankid/' + zadostData.idzadosti
            : '/nezarazeny-ucet-zjisteni/bankid';
        history.push(path);
    };

    const onClick = () => {
        token &&
            !disableSubmit &&
            zadostData?.idzadosti &&
            (setDisableSubmit(true),
            nuPlatbaApi(token, zadostData?.idzadosti)
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .then((resp: any) => {
                    window.open(resp.urlbankid, '_parent'); // Redirectne uzivatele na stranky platebni brany
                })
                .catch((err: AxiosError) => {
                    setErrStatus(err.response?.status);
                    setDisableSubmit(false);
                }));
    };

    return (
        <>
            {errStatus ? (
                <Col span={24}>
                    <Row>
                        {errStatus === 400 ? (
                            <Title text="RESPONSE_ERROR_400" level={3} />
                        ) : errStatus === 401 ? (
                            <Title text="RESPONSE_ERROR_401" level={3} />
                        ) : errStatus === 404 ? (
                            <Title text="RESPONSE_ERROR_404" level={3} />
                        ) : errStatus === 500 ? (
                            <Title text="RESPONSE_ERROR_500" level={3} />
                        ) : errStatus ? (
                            <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                        ) : null}
                    </Row>

                    <Row className="statement-buttons-row">
                        <ButtonComponent buttontext="PREJIT_ZPET_NA_PRIHLASENI" onClick={routeChange} />
                    </Row>
                </Col>
            ) : (
                <>
                    <h1>
                        <TranslateText>SHRNUTI_OBJEDNAVKY</TranslateText>
                    </h1>
                    <Row>
                        <Paragraph text="STAV_PLODLO" />
                    </Row>

                    <div className="section-shrnuti-objednavky">
                        {/* <div>
                            <Paragraph text="SHRNUTI_OBJEDNAVKY" strong={true} />
                        </div>

                        <div>
                            <Paragraph text="ZADATEL" strong={true} />
                        </div> */}
                        <h3>
                            <TranslateText>ZADATEL</TranslateText>
                        </h3>
                        <div className="section-zadatel">
                            <Row>
                                <Col span={24} className="detail">
                                    <TranslateText>{zadostData?.jmeno ? zadostData?.jmeno : '-'}</TranslateText>{' '}
                                    <TranslateText>{zadostData?.prijmeni ? zadostData?.prijmeni : '-'}</TranslateText>
                                </Col>
                            </Row>

                            <Row>
                                <Paragraph text={zadostData?.email ? zadostData?.email : '-'} />
                            </Row>

                            <Row>
                                {/* <Paragraph
                                text={
                                    zadostData?.telefon
                                        ? zadostData?.telefon
                                        : contactInfoPhone
                                        ? contactInfoPhone
                                        : '-'
                                }
                            /> */}
                                <Paragraph text={zadostData?.telefon ? formatNumber(zadostData.telefon) : ''} />
                            </Row>

                            <Row>
                                <Paragraph text="FORMA_UHRADY" />
                            </Row>
                        </div>

                        <Row>
                            <Col span={24} className="detail">
                                <TranslateText>RC_ZADATELE</TranslateText>: {zadostData?.rodnecislo}
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} className="detail">
                                <TranslateText>SPISOVA_ZNACKA</TranslateText>: {zadostData?.cjdedictvi}
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} className="detail">
                                <TranslateText>CELKOVA_CASTKA</TranslateText>: {70 + ' Kč'}
                            </Col>
                        </Row>
                    </div>

                    <Row className="statement-buttons-row">
                        <ButtonComponent
                            htmlType="submit"
                            buttontext="ZAPLATIT"
                            onClick={onClick}
                            disabled={disableSubmit}
                        />
                    </Row>
                </>
            )}
        </>
    );
};

export default PLODLO;
